import React from 'react';
import {
    Form, Row, Col, Input, Select, Button, InputNumber, DatePicker, Icon
} from 'antd';
import MiCompAPI from "../../util/api";
import moment from "moment";

const { Option } = Select;
class ETP extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            remib_type: []

        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.submitHandler({ ...values,profile_start_date:values.profile_start_date&&new Date(values.profile_start_date).toDateString(),profile_end_date:values.profile_end_date&&new Date(values.profile_end_date).toDateString(), tier_profile_id: this.props.profile ? this.props.profile.tier_profile_id : 0, tier_id: this.props.tier_id });

            }
        });
    }

    getClientMasters = () => {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({

                        remib_type: data.remib_type,

                    });
                }
            },
            ["TEMIB_TYPE"]
        );
    }
    componentWillUnmount = () => {

    }
    componentDidMount = () => {
        this.getClientMasters();
        const { setFieldsValue } = this.props.form;


        if (this.props.profile) {
            setTimeout(() => {
                setFieldsValue({
                    profile_tier1: this.props.profile.tier1,
                    profile_tier2: this.props.profile.tier2,
                    profile_tier3: this.props.profile.tier3,
                    profile_tier4: this.props.profile.tier4,
                    profile_tier5: this.props.profile.tier5,
                    profile_tier6: this.props.profile.tier6,
                    profile_tier7: this.props.profile.tier7,
                    profile_tier8: this.props.profile.tier8,
                    profile_tier9: this.props.profile.tier9,
                    profile_tier10: this.props.profile.tier10,
                    tier_profile_name: this.props.profile.tier_profile_name,
                    profile_start_date: this.props.profile.start_date ? moment(new Date(this.props.profile.start_date)) : null,
                    profile_end_date: this.props.profile.end_date ? moment(new Date(this.props.profile.end_date)) : null,
                    min_allow: this.props.profile.min_allow,
                    max_allow: this.props.profile.max_allow,
                    qualifier_value: this.props.profile.qualifier_value,
                    new_add_renewal: this.props.profile.new_add_renewal,
                    reimb_type_id: this.props.profile.reimb_type_id,
                    reimb_cal_meth: this.props.profile.reimb_cal_meth,
                    //    isLSPayment:this.props.profile.isLSPayment,
                    //    isProrated:this.props.profile.isProrated,                 
                });
            }, 100);

        }


    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { remib_type } = this.state;

        return (
            <div className="mi_model_popup">

                <Row span={24}>
                    <Col span={18}>
                        <p className='mi_title' style={{ marginLeft: '8px' }}>{this.props.profile ? "Edit Profile" : "Add Profile"}
                        </p>

                    </Col>
                    <Col span={6}>
                        <i className="fa fa-times mi_icon mi_icon_red mi_button_close" onClick={this.props.closeDrawerHandler} ></i>
                    </Col>
                </Row>
                <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                    <Row md={24}>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Profile Name</legend>
                                    {getFieldDecorator(`tier_profile_name`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter Profile Name.",
                                            },
                                        ],
                                    })(<Input autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Profile Name *' />
                                    )}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Qualifier Value</legend>
                                    {getFieldDecorator(`qualifier_value`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter Qualifier Value.",
                                            },
                                        ],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Qualifier Value *' />
                                    )}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Start Date</legend>
                                    {getFieldDecorator(`profile_start_date`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter Start Date.",
                                            }
                                        ],
                                    })(<DatePicker autoComplete={"nope"} format="MM/DD/YYYY" className="mi_input" placeholder='Plese Select Start Date *' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">End Date</legend>
                                    {getFieldDecorator(`profile_end_date`, {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Please enter End Date.",
                                            },
                                            {
                                                validator(rule, value) {
                                                    if (!value || getFieldValue(`profile_start_date`) <= value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject('End date must be greater than Start Date');
                                                }
                                            }
                                        ],
                                    })(<DatePicker autoComplete={"nope"} format="MM/DD/YYYY" className="mi_input" placeholder='Plese Select End Date' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Minimum Allow</legend>
                                    {getFieldDecorator(`min_allow`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter Minimum Allow.",
                                            },
                                        ],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Minimum Allow *' />
                                    )}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Maximum Allow</legend>
                                    {getFieldDecorator(`max_allow`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter Maximum Allow.",
                                            },
                                        ],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Maximum Allow *' />
                                    )}
                                </fieldset>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Reimbursement Type</legend>
                                    {getFieldDecorator(`reimb_type_id`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please select Reimbursement Type.",
                                            },
                                        ],
                                    })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                        placeholder="Please Select Reimbursement Type *">
                                        {remib_type.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                                    </Select>)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item
                            >
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Calculation Method</legend>
                                    {getFieldDecorator(`reimb_cal_meth`, {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please select Calculation Method.",
                                            },
                                        ],
                                    })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                        placeholder="Please Select Calculation Method">
                                        <Option value={true} key={true}>Percentage</Option>
                                        <Option value={false} key={false}>Fixed</Option>
                                    </Select>)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font" id="number">Tier 1</legend>
                                    {getFieldDecorator(`profile_tier1`, {
                                        rules: [{ required: false, message: 'Please enter Tier 1' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier1')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 1');
                                            }
                                        },],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 1' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 2</legend>
                                    {getFieldDecorator(`profile_tier2`, {
                                        rules: [{ required: false, message: 'Please enter Tier 2' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier2')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 2');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 2' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 3</legend>
                                    {getFieldDecorator(`profile_tier3`, {
                                        rules: [{ required: false, message: 'Please enter Tier 3' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier3')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 3');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 3' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>

                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 4</legend>
                                    {getFieldDecorator(`profile_tier4`, {
                                        rules: [{ required: false, message: 'Please enter Tier 4' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier4')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 4');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 4' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 5</legend>
                                    {getFieldDecorator(`profile_tier5`, {
                                        rules: [{ required: false, message: 'Please enter Tier 5' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier5')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 5');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 5' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 6</legend>
                                    {getFieldDecorator(`profile_tier6`, {
                                        rules: [{ required: false, message: 'Please enter Tier 6' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier6')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 6');
                                            }
                                        }],
                                    })(<Input autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 6' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 7</legend>
                                    {getFieldDecorator(`profile_tier7`, {
                                        rules: [{ required: false, message: 'Please enter Tier 7' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier7')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 7');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 7' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 8</legend>
                                    {getFieldDecorator(`profile_tier8`, {
                                        rules: [{ required: false, message: 'Please enter Tier 8' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier8')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 8');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 8' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 9</legend>
                                    {getFieldDecorator(`profile_tier9`, {
                                        rules: [{ required: false, message: 'Please enter Tier 9' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier9')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 9');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 9' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        <Col md={8} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Tier 10</legend>
                                    {getFieldDecorator(`profile_tier10`, {
                                        rules: [{ required: false, message: 'Please enter Tier 10' },
                                        {
                                            validator(rule, value) {
                                                if (value || !getFieldValue('tier10')) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Please enter Tier 10');
                                            }
                                        }],
                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 10' />)}
                                </fieldset>
                            </Form.Item>
                        </Col>


                    </Row>
                    <Row span={24} style={{ marginTop: '30px' }}>
                        <Col span={7}>

                        </Col>
                        <Col span={5}>

                            <Button className="mi_button_right submit-button" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                                Cancel
                            </Button>

                        </Col>
                        <Col span={5}>

                            <Button htmlType="submit" className="submit-button" type="primary" >
                                Submit
                            </Button>

                        </Col>

                        <Col span={7}>
                        </Col>
                    </Row>
                </Form>
            </div >
        )
    }
}
const AddProfile = Form.create()(ETP);
export default AddProfile;